<template>
  <!-- 页面不存在 -->
  <div class="bg-white absolute-100-percent">
    <empty-notice :image="'search'" :desc="'页面不存在'"></empty-notice>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    methods: {}
  }
</script>

<style scoped>
</style>
